import {call} from 'redux-saga/effects';
import {Storage} from 'aws-amplify';

export default path => call([Storage, 'get'], path);
